import React from "react";
import ButtonList from "./ButtonList";
import VideoContainer from "./VideoContainer";
const MainContainer=()=> <div className="min-w-0 bg-[#0f0f0f]"><ButtonList/><VideoContainer/></div>;
export default MainContainer;
